'use client'
import { useState, useEffect } from "react"

export function PWAUpdater() {
  const [isSupported, setIsSupported] = useState(false)

  // TODO: 实现新版本更新
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      setIsSupported(true)
      // 注册失败时静默处理，避免变成未捕获的 Promise 拒绝（ARMS 上报为 "Rejected"）
      registerServiceWorker().catch(() => {})
    }
  }, [])

  async function registerServiceWorker() {
    await navigator.serviceWorker.register('/sw.js')
  }


  return (
    <></>
  )
}